import { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import css from './FAQ.module.css';

const FAQ = ({ faq }) => {
    if (!faq || faq.length === 0) return null;
    const [openSet, setOpenSet] = useState(() => new Set([0]));

    const toggle = i => {
        setOpenSet(prev => {
            const next = new Set(prev);
            next.has(i) ? next.delete(i) : next.add(i);
            return next;
        });
    };

    return (
        <div className={css.panel}>
            <h4 className={css.heading}>
                <FormattedMessage id="FAQ.heading" defaultMessage="Frequently Asked Questions" />
            </h4>
            <div className={css.faqList}>
                {faq.map((item, i) => {
                    const isOpen = openSet.has(i);
                    const questionId = `faq-question-${i}`;
                    const answerId = `faq-answer-${i}`;
                    return (
                        <div key={i} className={css.faqItem}>
                            <button
                                id={questionId}
                                type="button"
                                className={`${css.question} ${isOpen ? css.open : ''}`}
                                onClick={() => toggle(i)}
                                aria-expanded={isOpen}
                                aria-controls={answerId}
                            >
                                {item.question}
                                <span className={css.arrow}>{isOpen ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.9999 10.8284L7.0502 15.7782L5.63599 14.364L11.9999 8L18.3639 14.364L16.9497 15.7782L11.9999 10.8284Z" fill="#535862" />
                                </svg>
                                    : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z" fill="#535862" />
                                    </svg>
                                }</span>
                            </button>
                            <div
                                id={answerId}
                                role="region"
                                aria-labelledby={questionId}
                                className={`${css.answer}`}
                                hidden={!isOpen}
                                aria-hidden={!isOpen}
                            >
                                {item.answer}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

FAQ.propTypes = {
    faq: PropTypes.arrayOf(PropTypes.shape({
        question: PropTypes.string.isRequired,
        answer: PropTypes.string.isRequired,
    })),
};

export default FAQ;
